import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// The mutation query re-selects project.quote so the Relay store learns about the published
// quote immediately — the Baseline page's locked state renders without a refetch.
const mutation = graphql`
	mutation createQuoteMutation($input: CreateQuoteInput!) {
		createQuote(input: $input) {
			project {
				id
				quote {
					id
					status
					revisionNumber
					expiryDate
					templateJson
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError, uploadables) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		uploadables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
